import { useTranslation } from "react-i18next";

/**
 * LanguageToggle — pill que alterna ES ↔ EN.
 * Usa localStorage (clave `commandix_lang`) para persistir la elección.
 */
export default function LanguageToggle({ className = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "es").slice(0, 2).toLowerCase();
  const next = current === "es" ? "en" : "es";

  return (
    <button
      type="button"
      onClick={() => i18n.changeLanguage(next)}
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/5 border border-white/10 text-xs uppercase tracking-[0.15em] font-bold text-zinc-300 hover:text-white hover:bg-white/10 transition ${className}`}
      data-testid="lang-toggle"
      aria-label={`Switch language to ${next}`}
    >
      <span className={current === "es" ? "text-[#FF7A00]" : "opacity-50"}>ES</span>
      <span className="text-zinc-700">/</span>
      <span className={current === "en" ? "text-[#FF7A00]" : "opacity-50"}>EN</span>
    </button>
  );
}
